import { colors, cssThemedValue, elevationCss } from '@creditornot/cb-ingredients';
import styled from 'styled-components';
export const COLLAPSE_TRANSITION_MS = 200;

export const LeftNavigation = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: visible;
`;

export const NavigationContainer = styled.div<{ collapsed: boolean }>`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  width: ${({ collapsed }) => (collapsed ? '24px' : '320px')};
  border-inline-end: 1px solid ${cssThemedValue('borderPrimary')};
  transition: width ${COLLAPSE_TRANSITION_MS}ms;
  pointer-events: all;
  &::after {
    content: '';
    position: absolute;
    left: ${({ theme }) => (theme.cbDirection === 'ltr' ? 0 : 'auto')};
    right: ${({ theme }) => (theme.cbDirection === 'ltr' ? 'auto' : 0)};
    top: 0;
    background-color: ${cssThemedValue('surfaceMain')};
    opacity: ${({ collapsed }) => (collapsed ? 1 : 0)};
    width: ${({ collapsed }) => (collapsed ? '24px' : '320px')};
    height: 100%;
    pointer-events: ${({ collapsed }) => (collapsed ? 'all' : 'none')};
    transition: all ${COLLAPSE_TRANSITION_MS}ms;
    z-index: 1;
    border-inline-end: 1px solid ${cssThemedValue('borderPrimary')};
  }

  /*** scrollbar customization ***/

  /* Firefox */
  scrollbar-width: thin;
  /* ignore-color */
  scrollbar-color: ${colors.pepper32} transparent;

  /* Chrome/Edge/Safari */
  &::-webkit-scrollbar {
    width: 12px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${cssThemedValue({ light: colors.pepper32, dark: colors.salt36 })};
    border-radius: 20px;
    border: 3px solid ${({ theme }) => theme.cbSemanticColors.surfaceMain};
  }
`;

export const CollapseButton = styled.div<{ collapsed: boolean }>`
  ${elevationCss(6)};
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  top: 32px;
  left: ${({ theme, collapsed }) => {
    if (theme.cbDirection !== 'ltr') {
      return 'auto';
    }
    return collapsed ? '12px' : '308px';
  }};
  right: ${({ theme, collapsed }) => {
    if (theme.cbDirection === 'ltr') {
      return 'auto';
    }
    return collapsed ? '12px' : '308px';
  }};
  margin-block-start: -12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all ${COLLAPSE_TRANSITION_MS}ms;
  z-index: 2;
  svg {
    width: 12px;
    fill: ${cssThemedValue('textPrimary')};
  }
  &:active svg {
    fill: ${cssThemedValue('textSecondary')};
  }
  &:hover {
    ${elevationCss(16)};
  }
`;

export const Main = styled.div`
  flex: 1;
  overflow: auto;
`;
